import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

import { confirmPlanSold } from '../api/api';
import { paymentService } from '../services';
import { SuccessSearchTransactionByToken } from '../services/payment/abstraction';
import { GenericError } from '../services/types';
import { convertDate } from '../util';

type State = {
  loading: boolean;
  data?: {
    customerName: string;
    requestNro: string;
    unitName: string;
    dataPayment: { key: string; value: string | number }[];
  };
  error: boolean;
};
export const useQueryTokenWs = (): State => {
  const { search, state } = useLocation<{ searchWs: SuccessSearchTransactionByToken }>();
  const [{ loading, error, data }, setState] = useState<State>({
    loading: true,
    error: false,
  });

  const handlePostPayment = async (
    isOrderPaid: boolean | undefined,
    planSoldUUID: string | undefined | null
  ) => {
    if (!isOrderPaid || !planSoldUUID) {
      return;
    }

    try {
      await confirmPlanSold(isOrderPaid, planSoldUUID);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    void (async () => {
      try {
        let responseSuccess: SuccessSearchTransactionByToken;
        if (state && state.searchWs) {
          responseSuccess = state.searchWs;
        } else {
          if (!search || !search.includes('token_ws')) throw new Error();
          const tokenWs = new URLSearchParams(search).get('token_ws');
          if (!tokenWs || !tokenWs.trim()) throw new Error();
          const res = await paymentService.searchTransactionByToken({
            tokenWs,
          });
          if (!res || res instanceof GenericError) throw new Error(res?.message);
          responseSuccess = res;
          responseSuccess.tutenData = JSON.parse(responseSuccess.tutenData);
          responseSuccess.tutenOrderPayload = JSON.parse(responseSuccess.tutenOrderPayload);
        }

        const tutenData = responseSuccess?.tutenData || {};
        const tutenOrderPayload = responseSuccess?.tutenOrderPayload || {};

        const { isOrderPaid, planSoldUUID } = {
          isOrderPaid: responseSuccess?.isOrderPaid || false,
          planSoldUUID: tutenOrderPayload?.planSoldUUID || null,
        };

        await handlePostPayment(isOrderPaid, planSoldUUID);

        setState((prevState) => ({
          ...prevState,
          data: {
            requestNro: responseSuccess.tutenCaseId?.toString(),
            customerName: tutenData.personFullName,
            unitName: tutenData.unitName,
            dataPayment: [
              {
                key: 'No. de comprobante',
                value: responseSuccess.tutenOrderId?.toString(),
              },
              tutenData.personDocumentType
                ? {
                    key: tutenData.personDocumentType,
                    value: tutenData.personDocumentNumber,
                  }
                : [],
              {
                key: 'Fecha de pago',
                value: convertDate(responseSuccess.txDate || new Date()),
              },
              {
                key: 'Hora de pago',
                value: convertDate(responseSuccess.txDate || new Date(), 'hh:mm a'),
              },
              { key: 'Servicio', value: tutenOrderPayload.productName },
            ].flat(),
          },
        }));
      } catch (err) {
        console.error(err);
        setState((prevState) => ({ ...prevState, error: true }));
      } finally {
        setState((prevState) => ({ ...prevState, loading: false }));
      }
    })();
  }, []);
  return { loading, error, data };
};
